import { AppRoute } from '@/libs/routing';

export type ShareOutcome = 'shared' | 'copied' | 'cancelled';

/**
 * The web URL of a stop, from the configured base: `location` is not a public web
 * address in the native app (`capacitor://localhost`).
 */
export function buildStopShareUrl(groupId: string, stopId: string): string {
  const base = String(import.meta.env.VITE_WEB_BASE_URL).replace(/\/+$/, '');
  return `${base}/#/${encodeURIComponent(groupId)}/${AppRoute.MAP}/${AppRoute.STOP_DETAILED}/${encodeURIComponent(stopId)}`;
}

/** Throws when the share sheet failed and the clipboard is unavailable or refused. */
export async function shareLink(data: { title: string; url: string }): Promise<ShareOutcome> {
  if (navigator.share) {
    try {
      await navigator.share(data);
      return 'shared';
    } catch (error) {
      if (error instanceof DOMException && error.name === 'AbortError') return 'cancelled';
    }
  }
  // eslint-disable-next-line compat/compat -- iOS 11 is below our real support floor (plugin-legacy targets 'defaults, not IE 11'); .browserslistrc is intentionally broader.
  await navigator.clipboard.writeText(data.url);
  return 'copied';
}
